import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import CustomerNeeds from './CustomerNeeds';
import ProblemIdentification from './ProblemIdentification';
import Stakeholders from './Stakeholders';
import Validation from './Validation';
import References from './References';
const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};

const EntrepreneurshipCS = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#PDE') {
      setBackI(appColors['ColorB']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
    } else if (key === '#CNE') {
      setBackI('transparent');
      setBackII(appColors['ColorB']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
    } else if (key === '#SHE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorB']);
      setBackIV('transparent');
      setBackV('transparent');
    } else if (key === '#VE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorB']);
      setBackV('transparent');
    } else if (key === '#RE') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorB']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#PDE' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorB'], fontSize: '1.8vh'}}>Problem Identification</Text></Content>}/>
          <Link href='#CNE' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorB'], fontSize: '2.4vh'}}>Customer Needs</Text></Content>}/>
          <Link href='#SHE' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>Stakeholders</Text></Content>}/>
          <Link href='#VE' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>Validation</Text></Content>}/>
          <Link href='#RE' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorB'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> C&nbsp;<br/> U&nbsp;<br/> S&nbsp;<br/> T&nbsp;<br/> O&nbsp;<br/> M&nbsp;<br/> E&nbsp;<br/> R&nbsp;<br/> S&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['Colorx'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='PDE'>
              <ProblemIdentification/>
            </div>
            <div id='CNE'>
              <CustomerNeeds/>
            </div>
            <div id='SHE'>
              <Stakeholders/>
            </div>
            <div id='VE'>
              <Validation/>
            </div>
            <div id='RE'>
              <References/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default EntrepreneurshipCS;
